import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    // 延遲初始化，等待元素可見
    if (this.isElementVisible()) {
      this.initializeTomSelect()
    } else {
      // 如果元素不可見，監聽父元素的變化
      this.observer = new MutationObserver(() => {
        if (this.isElementVisible() && !this.tomSelect) {
          this.initializeTomSelect()
        }
      })
      
      // 監聽最近的父元素的 class 變化
      const parent = this.element.closest('[data-invoice-target]')
      if (parent) {
        this.observer.observe(parent, { attributes: true, attributeFilter: ['class'] })
      }
    }
  }

  isElementVisible() {
    return this.element.offsetParent !== null
  }

  initializeTomSelect() {
    if (this.tomSelect) return // 避免重複初始化
    
    this.tomSelect = new TomSelect(this.element, {
      plugins: [], // 移除 clear_button plugin，使用自訂的
      placeholder: '請選擇或搜尋捐贈單位',
      allowEmptyOption: true,
      maxOptions: null,
      closeAfterSelect: true,
      hidePlaceholder: true,
      searchField: ['text', 'value'], // 同時搜尋顯示文字和 value（代碼）
      score: function(search) {
        // 自訂搜尋評分函數，讓代碼和名稱都能被搜尋到
        const score = this.getScoreFunction(search);
        return function(item) {
          // 檢查選項文字是否包含搜尋詞
          const textScore = score(item);
          
          // 也檢查 value（代碼）是否包含搜尋詞
          if (item.value && item.value.toLowerCase().indexOf(search.toLowerCase()) > -1) {
            return Math.max(textScore, 0.5); // 給予較高分數
          }
          
          return textScore;
        };
      },
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results">找不到符合的結果</div>';
        }
      },
      onInitialize: function() {
        console.log('Tom Select initialized')
      }
    })

    // 添加自訂清除按鈕的點擊事件
    this.addCustomClearButton()
  }

  addCustomClearButton() {
    const control = this.element.parentElement.querySelector('.ts-control')
    if (!control) return

    control.addEventListener('click', (e) => {
      // 檢查是否點擊到右側的清除區域（最右邊 3rem 範圍）
      const rect = control.getBoundingClientRect()
      const clickX = e.clientX - rect.left
      const clearButtonArea = rect.width - 48 // 3rem = 48px
      
      if (clickX >= clearButtonArea && this.tomSelect.items.length > 0) {
        e.stopPropagation()
        this.tomSelect.clear()
      }
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
